/**
 * @licence MIT
 * @author Sergey Melyukov
 */

module.exports = require('./main');



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/